<template>
  <div id="profile-edit" class="sav-wrapper">
    <Spinner v-if="isLoading"/>
    <Topbar/>
    <div class="sav-container">
        <h1 id="header-title">
            <a href="javascript:void(0)" @click="goBack">
                <img id="header-back-btn" :src="require('./../../assets/icons/arrow-back.png')" alt="Επιστροφή">
            </a>
            <span>Επεξεργασία Προφίλ</span>
        </h1>

        <div class="sav-card">
            <div class="sav-card-header">
            </div>
            <div class="sav-card-entries">
                <div class="sav-card-entry">
                    <h3>Όνομα</h3>
                    <input
                      :class="{ 'error': !userData.name && submitted }"
                      id="name" name="name" type="text" v-model.trim="userData.name" 
                    >
                </div>
                <div class="sav-card-entry">
                    <h3>Username</h3>
                    <input
                      :class="{ 'error': !userData.username && submitted }"
                      id="username" name="username" type="text" v-model.trim="userData.username" 
                    >
                </div>
                <div class="sav-card-entry">
                    <h3>Email</h3>
                    <input
                      :class="{ 'error': !userData.email && submitted }"
                      id="email" name="email" type="text" v-model.trim="userData.email" 
                    >
                </div>
            </div> 
            <div class="sav-card-footer">
                <span class="sav-card-log">Τελευταία αλλαγή στις {{ formatDate(userData['modified_date']) }}</span>
                <div class="sav-card-buttons">
                  <div v-if="errorMsg" id="error-msg" class="flex flex-align-items-center">
                    <b>{{ errorMsg }}</b> 
                  </div>
                  <a href="javascript:void(0)" @click="goBack" class="sav-btn sav-btn-link">Ακύρωση</a>
                  <button @click="validateForm" type="submit" class="sav-btn sav-btn-red">Αποθήκευση αλλαγών</button>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Spinner from './../Spinner.vue'
import Topbar from './../Topbar.vue'

export default {
  props: [],
  components: {
    Spinner,
    Topbar
  },
  data() {
    return {
      isLoading: true,
      apiUrl: this.$parent.apiUrl,
      userData: '',
      errorMsg: '',
      submitted: false,
    }
  },
  methods: {
    formatDate: function (date) {
        // format date dd/mm/yyyy
        let newDate = new Date(date);
        return this.sliceNumber(newDate.getDate(), 2) + "/" + this.sliceNumber(newDate.getMonth() + 1, 2) + "/" + this.sliceNumber(newDate.getFullYear(), 4)
    },
    sliceNumber: function(number, slice) {
      // return number with custom number of digits
      return ("0" + number).slice(-1 * slice);
    },
    validateForm () {
      // flag for checking if user has submitted once
      this.submitted = true;
      
      if (this.userData.name == "" || this.userData.email == "" || this.userData.username == "") {
        this.errorMsg = "Συμπληρώστε όλα τα πεδία"
      } else {
        this.submit();
      }
    },
    submit () {
      let vm = this;
      this.isLoading = true;

      let url = this.apiUrl + "/post/profile";
      let formData = {
        user: JSON.parse(localStorage.getItem('sav-erp-user')),
        token: this.$cookie.get('sav-erp-token'),
				refreshToken: this.$cookie.get('sav-erp-refresh-token'),
        name: this.userData.name,
        username: this.userData.username,
        email: this.userData.email
      };

      axios.post(url, formData)
        .then(response => {
          if (response.status == 200) {
            localStorage.setItem('sav-erp-user', JSON.stringify(response.data.user));
            vm.errorMsg = "";
            vm.$router.push("/profile");
          }  else {
            vm.errorMsg = response.data ? response.data : response.status + " - " + response.statusText;
          } 
          vm.isLoading = false;
        })
        .catch(error => {
          let response = error.response;
          if (!response) {
            vm.errorMsg = "Μη ενεργός server";
          } else {
            vm.errorMsg = response.data ? response.data : response.status + " - " + response.statusText;
          }
          vm.isLoading = false;
        });
    },
    goBack: function () {
      this.$router.go(-1);
    }
  },
	mounted () {
    const vm = this;
    let formData = {
      user: JSON.parse(localStorage.getItem('sav-erp-user')),
      token: this.$cookie.get('sav-erp-token'),
      refreshToken: this.$cookie.get('sav-erp-refresh-token')
    };

    let headers = { 
			headers: {
			'Content-type': 'application/json',
			}
		};
    
    axios.post(this.apiUrl + '/get/profile/', formData, headers)
      .then(response => {
        vm.isLoading = false;
        if (response.status == 200) {
          this.$cookie.set('sav-erp-token', response.data.token, { expires: '15m' });
          vm.errorMsg = '';
          vm.userData = response.data.data[0];
        } else {
					vm.errorMsg = response.data ? response.data : response.status + " - " + response.statusText;
				}
      })
      .catch(error => {
        let response = error.response;
        
        if (!response) {
          this.errorMsg = "Μη ενεργός server";
        } else {
          if (response.status == 401) {
            localStorage.removeItem('user');    
            vm.$cookie.delete('sav-erp-token');
            vm.$cookie.delete('sav-erp-refresh-token');
            vm.$router.push("/login");
          } else {
            vm.errorMsg = response.data ? response.data : response.status + " - " + response.statusText;
          }
        }
        vm.isLoading = false;
      });
	}
}
</script>

<style lang="scss" scoped>
@import "./../../scss/_colors";
.sav-card-entry {
    margin-right: 0;
    &:not(:nth-child(3n)) {
        margin-right: 20px;
    }
}

#header-back-btn {
  height: 22px;
}

#header-title {
  font-weight: 500;
  margin-bottom: 30px;
  :not(:last-child) {
    margin-right: 15px;
  }
}

.sav-card-header {
  height: 52px;
}

#error-msg {
	color: $red;
	font-weight: 400;
	padding: 10px;
	margin-right: 10px;
}
</style>
